<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div
        class="row table-responsive"
        style="margin: 0 !important"
      >
        <div class="form-group margin-0 table-wrap">
          <div style="flex:1">
            <el-table :data="judgeAssignList" :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" @selection-change="handleJudgeAssignSelectionChange" style="border:2px solid black;">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column type="index" label="S/N" fixed width="60">
              </el-table-column>
              <el-table-column prop="userName" label="Judge Name">
              </el-table-column>
              <el-table-column prop="assignGroup" label="Assigned Panel">
              </el-table-column>
            </el-table>
            <el-col :span="24" class="el-table_footertoolbar">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleJudgeAssignPageSizeChange"
                @current-change="handleJudgeAssignPageCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="judgeAssignPageInfo.pageSize"
                :total="judgeAssignPageInfo.total"
                style="float: right"
              >
              </el-pagination>
            </el-col>
          </div>
          <div class="button-wrap">
            <el-button type="primary" icon="el-icon-bottom" @click="handleAssignToGroup">Assign</el-button>
          </div>
        </div>
       </div>
       <div
        class="row table-responsive"
        style="margin: 0 !important"
      >
        <div class="form-group margin-0 table-wrap">
          <el-tabs v-model="currentGroupId" type="card" @tab-click="handleSelectGroup" style="flex:1" :before-leave='handleIsAddGroup'>
            <el-tab-pane :label="`${item.groupName} (${item.judgeCount})`" :name="item.id+''" v-for="item in groupList" :key="item.id">
              <el-table :data="judgeAssignInGroupList" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }" @selection-change="handleSelectGroupItem" style="border:2px solid black;">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column type="index" label="S/N" fixed width="60">
                </el-table-column>
                <el-table-column prop="userName" label="Judge Name">
                </el-table-column>
                <el-table-column prop="assignedBy" label="Assigned By"></el-table-column>
              </el-table>
               <el-col :span="24" class="el-table_footertoolbar">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleGroupPageSizeChange"
                @current-change="handleGroupPageCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="item?item.pageSize:0"
                :total="item?item.groupTotal0:0"
                style="float: right"
              >
              </el-pagination>
            </el-col>
            </el-tab-pane>
            <el-tab-pane name="addGroup">
              <span slot="label"><i class="el-icon-plus"></i> Add Panel</span>
            </el-tab-pane>
          </el-tabs>
            
          <div class="button-wrap" style="padding-top:40px;">
            <el-button type="primary" icon="el-icon-top" @click="handleRemoveByGroup">Remove</el-button>
          </div>
        </div>
       </div>
    </div>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios"

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      userInfo:{userId:'',token:''},
      judgeAssignList:[],
      judgeAssignSelectedList:[],
      judgeAssignPageInfo:{pageIndex:1,pageSize:10,total:0},
      currentGroupId:'0',
      groupList:[],
      judgeAssignInGroupList:[],
      judgeAssignSelectedByGrouoList:[]
    }
  },

  created() {
    this.intiPage()

  },
  mounted() {
  },
  components: {},
  computed:{
    baseURL(){
      return config.domain+'/'
    }
  },
  methods: {
    getUserInfo(){
      this.userInfo=this.getAuthObj();
    },
    async intiPage(){
      this.getUserInfo()
      await this.getJudgeAssignList()
      await this.getGroupList()
      await this.getJudgeAssignInGroupListByGroupId(this.currentGroupId)
    },
    async getJudgeAssignList(){
      const params={
        ...this.userInfo,
        ...this.judgeAssignPageInfo
      }
       const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getAllJudgeAssign', params)
      if(status_code=='0') {
        this.judgeAssignPageInfo.total=result.total
        this.judgeAssignList=result.judgeList
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    handleJudgeAssignSelectionChange(val){
      this.judgeAssignSelectedList=val
    },
    handleJudgeAssignPageSizeChange(val){
      this.judgeAssignPageInfo.pageSize = val;
      this.getJudgeAssignList()
    },
    handleJudgeAssignPageCurrentChange(val){
      this.judgeAssignPageInfo.pageIndex=val
      this.getJudgeAssignList()
    },
    async handleAssignToGroup(){
      if(!this.judgeAssignSelectedList.length) return
       let stemupUploadIds= ''
      this.judgeAssignSelectedList.forEach((item,index)=>{
        if(this.judgeAssignSelectedList.length-1>index) stemupUploadIds += item.id +','
        else stemupUploadIds += item.id
      })
      const params ={
        ...this.userInfo,
        groupId:this.currentGroupId,
        judgesIds:stemupUploadIds
      }
      const {data:{status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/assignJudge',params )
      if(status_code=='0') {
        this.judgeAssignSelectedList=[]
        this.getJudgeAssignList()
        this.getJudgeAssignInGroupListByGroupId(this.currentGroupId)
        this.getGroupList()
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async getGroupList(){
      const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getJudgeGroupList', {...this.userInfo})
      if(status_code=='0') {
        this.groupList= result
        this.groupList.forEach(i=>{
          i.pageIndex=1,
          i.pageSize=10,
          i.groupTotal=0
        })
        if(this.groupList.length && !Number(this.currentGroupId)) this.currentGroupId = this.groupList[0].id + ''
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async getJudgeAssignInGroupListByGroupId(id){
      let groupRow=this.groupList.find(i=>{
        return i.id+'' == id
      })
      if(!groupRow) return
      const params={
        groupId:id,
        pageIndex:groupRow?groupRow.pageIndex:1,
        pageSize:groupRow?groupRow.pageSize:10,
        ...this.userInfo
      }
      const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getAllJudgeAssignGroup', params)
      if(status_code=='0') {
        groupRow.groupTotal=result.total
        this.judgeAssignInGroupList=result.judgeList
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    addGroup(){
      this.$confirm('Confirm to add a new Panel?', 'System Message', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'}).then(async () => {
            const lastGroupName=this.groupList.length?this.groupList[this.groupList.length-1].groupName:"0"
            const newGroupName='Panel ' + (Number(lastGroupName.charAt(lastGroupName.length-1)) + 1)
            const params={
              groupName:newGroupName,
              ...this.userInfo
            }
            const {data:{status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/addGroup',params )
            if(status_code=='0') {
              this.getGroupList()
            }else{
              this.$store.getters.warning.warningMsg = status_message;
              this.$store.getters.warning.warningFalg = true;
            }
          }).catch(()=>{
            
          })
          
    },
    handleIsAddGroup(name){
      if(name=="addGroup") return false
    },
    handleSelectGroup(tab){
      if(tab.name=="addGroup") return this.addGroup()
      this.getJudgeAssignInGroupListByGroupId(tab.name)
    },
    handleSelectGroupItem(val){
      this.judgeAssignSelectedByGrouoList=val
    },
    handleGroupPageSizeChange (val){
      const group = this.groupList.find(i =>{
        return i.id+''  == this.currentGroupId
      })
      group.pageSize = val
      this.getJudgeAssignInGroupListByGroupId(this.currentGroupId)
    },
    handleGroupPageCurrentChange (val){
      const group = this.groupList.find(i =>{
        return i.id+''  == this.currentGroupId
      })
      group.pageIndex = val
      this.getJudgeAssignInGroupListByGroupId(this.currentGroupId)
    },
    async handleRemoveByGroup(){
      if(!this.judgeAssignSelectedByGrouoList.length) return
      let stemupUploadIds= ''
      this.judgeAssignSelectedByGrouoList.forEach((item,index)=>{
        if(this.judgeAssignSelectedByGrouoList.length-1>index) stemupUploadIds += item.id +','
        else stemupUploadIds += item.id
      })
      const params={
        ...this.userInfo,
        type:1, //1stemup 2hsbc 写死就好
        ids:stemupUploadIds
      }
      const {data:{status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/removeJudge',params )
      if(status_code=='0') {
        this.judgeAssignSelectedByGrouoList=[]
        this.getJudgeAssignList()
        this.getJudgeAssignInGroupListByGroupId(this.currentGroupId)
        this.getGroupList()
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-wrap{
  display:flex;
  .button-wrap{
    display:flex;
    justify-content: center;
    align-items: center;
    margin:0 50px;
  }
}
::v-deep .el-tabs__header{
  margin: 0;
}
</style>
